import { render, staticRenderFns } from "./SettingApplicantAutoReplySelection.vue?vue&type=template&id=531cff4f"
import script from "./SettingApplicantAutoReplySelection.vue?vue&type=script&lang=js"
export * from "./SettingApplicantAutoReplySelection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports